import { selecetedShopIdActionTypes } from './selected-shop-id-reducer';

export enum vouchersReducerActionTypes {
  UPDATE_VOUCHERS = 'VOUCHERS_UPDATE_VOUCHERS',
}

interface VouchersUpdateVouchersAction {
  type: vouchersReducerActionTypes.UPDATE_VOUCHERS;
  payload: any[];
}

interface SelecetedShopIdAction {
  type: selecetedShopIdActionTypes.SELECTED_SHOP_ID_UPDATE;
  payload: string;
}

// combine all the action types into one type
export type VouchersReducerAction = VouchersUpdateVouchersAction | SelecetedShopIdAction;

export type VouchersReducerState = any[];

export const vouchersReducerInitialState: VouchersReducerState = [];

const vouchersReducer = (
  state: VouchersReducerState,
  action: VouchersReducerAction
): VouchersReducerState => {
  switch (action.type) {
    case vouchersReducerActionTypes.UPDATE_VOUCHERS: {
      return action.payload;
    }
    case selecetedShopIdActionTypes.SELECTED_SHOP_ID_UPDATE: {
      return vouchersReducerInitialState;
    }
    default:
      return state;
  }
};

export default vouchersReducer;
